import type {QueryFunctionContext, UseQueryOptions} from '@tanstack/react-query'
import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'

import {getTextTopics} from '@/services/messageService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'
import type {TextTopics} from '@/views/Chat/components/DefaultMessage/DefaultMessage'

function getTextTopicsQueryKey() {
  return ['textTopicsWithCategory'] as const
}

function getTextTopicsQueryOptions<TData = TextTopics, TError = Error>(
  options?: Omit<UseQueryOptions<TextTopics, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getTextTopicsQueryKey(),
    queryFn: async ({signal}: QueryFunctionContext) => {
      return await getTextTopics({signal})
    },
    placeholderData: keepPreviousData,
    ...NO_REFETCH_OPTIONS,
    ...options,
  })
}

export default function useTextTopics<TData = TextTopics, TError = Error>(
  options?: Omit<UseQueryOptions<TextTopics, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return useQuery(getTextTopicsQueryOptions<TData, TError>(options))
}
